/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Footer_About_Links1Inputs */

const vi_sitesettings_footer_about_links1 = /** @type {(inputs: Sitesettings_Footer_About_Links1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link giới thiệu`)
};

/**

* @param {Sitesettings_Footer_About_Links1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_footer_about_links1 = /** @type {((inputs?: Sitesettings_Footer_About_Links1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Footer_About_Links1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_footer_about_links1(inputs)
});
export { sitesettings_footer_about_links1 as "siteSettings_footer_about_links" }